import { Component, Input, Output, OnInit, OnChanges, EventEmitter, ViewChild, ElementRef, ViewEncapsulation } from '@angular/core';
import { DropdownValue } from './dropdown.model';

@Component({
    selector: 'dropdown',
    templateUrl: 'dropdown.component.html',
    encapsulation: ViewEncapsulation.None,
    host: {
        '(document:click)': 'onClick($event)',
    },
})
export class DropdownComponent implements OnInit, OnChanges {
    @Input()
    values: DropdownValue[];

    @Input()
    useLightClass: boolean = false;

    @Input()
    prefix: string;

    @Input()
    disabled: boolean = false;

    @Input()
    selectedItem: DropdownValue;

    @Input()
    resetSelectionOnValuesChanged: boolean = false;

    @Output()
    valueChange: EventEmitter<DropdownValue> = new EventEmitter<DropdownValue>();;

    @ViewChild('dropdown') el: ElementRef;

    public selectedText: string;

    constructor() {
        this.values = this.values || [];
        this.prefix = this.prefix || "";
    }

    ngOnInit() {
        this.setCurrentSelection(this.selectedItem);
    }

    ngOnChanges(changes) {
        if (changes && changes.selectedItem)
            this.setCurrentSelection(changes.selectedItem.currentValue);

        if (changes && changes.values && (this.resetSelectionOnValuesChanged || this.valuesChanged(changes.values.currentValue, changes.values.previousValue)))
            this.resetSelection();
    }

    public onValueChange(event: Event, item: DropdownValue) {
        event.preventDefault();
        event.stopPropagation();

        var $option = $(event.target);
        var $dropdown = $(this.el.nativeElement);

        $dropdown.find('.selected').removeClass('selected');
        $option.addClass('selected');

        let selectionText = $option.data('display') || $option.text();
        this.selectedText = this.getPrefix() + selectionText;
        $dropdown.toggleClass('open');
        this.valueChange.emit(item);
    }

    public onMenuClick(event) {
        if (this.disabled)
            return;
        var $dropdown = $(this.el.nativeElement);
        $('.nice-select').not($dropdown).removeClass('open');
        $dropdown.toggleClass('open');

        if ($dropdown.hasClass('open')) {
            $dropdown.find('.option');
            $dropdown.find('.focus').removeClass('focus');
            $dropdown.find('.selected').addClass('focus');
        } else {
            $dropdown.focus();
        }
    }

    onClick(event) {
        if ($(event.target).closest('.nice-select').length === 0) {
            $('.nice-select').removeClass('open').find('.option');
        }
    }

    private getPrefix(): string {
        if (this.prefix)
            return this.prefix + ": "
        return "";
    }

    setCurrentSelection(item: DropdownValue) {
        this.selectedText = this.getPrefix();

        if (item) {
            for (let v of this.values)
                if (v.value === item.value) {
                    this.selectedText += v.label;

                    var $dropdown = $(this.el.nativeElement);
                    $dropdown.find('.selected').removeClass('selected');
                    $dropdown.find('li').each(function () {
                        if ($(this).attr('value') === item.value.toString())
                            $(this).addClass('selected');
                    });
                    return;
                }
        }

        this.resetSelection();
    }

    resetSelection() {
        this.selectedText = this.getPrefix();
        var $dropdown = $(this.el.nativeElement);
        $dropdown.find('.selected').removeClass('selected');
    }

    private valuesChanged(oldValues: Array<DropdownValue>, newValues: Array<DropdownValue>): boolean {
        if ((!oldValues && newValues) || (oldValues && !newValues))
            return true;
        if (oldValues.length !== newValues.length)
            return true;
        let cloneOld = oldValues.slice(0);
        let cloneNew = newValues.slice(0);

        cloneOld.sort(function (a, b) { return a.value - b.value });
        cloneNew.sort(function (a, b) { return a.value - b.value })

        for (var i = 0; i < cloneOld.length; i++)
            if (cloneOld[i].value !== cloneNew[i].value)
                return true;

        return false;
    }

}


// WEBPACK FOOTER //
// ./src/app/shared/dropdown.component.ts